import { createAction } from '@ngrx/store';

import { MessagesPayloadType } from 'ish-core/store/core/messages';
import { httpError, payload } from 'ish-core/utils/ngrx-creators';

import {
  SaveForLater,
  SaveForLaterlineItem,
  UpdateSaveForLaterType,
} from '../../models/save-for-later/save-for-later.model';

export const loadSaveForLater = createAction('[Save For Later Internal] Load Save For Later Products');

export const loadSaveForLaterSuccess = createAction(
  '[Save For Later API] Load Save For Later Products Success',
  payload<{ saveForLaterList: SaveForLater }>()
);

export const loadSaveForLaterFail = createAction('[Save For Later API] Load Save For Later Products Fail', httpError());

export const addProductToSaveForLater = createAction(
  '[Save For Later Internal] Add Product to Save For Later',
  payload<{ basketLineItemId: string; successMessage?: MessagesPayloadType }>()
);

export const addProductToSaveForLaterSuccess = createAction(
  '[Save For Later API] Add Product to Save For Later Success',
  payload<{ saveForLaterList: SaveForLater; successMessage?: MessagesPayloadType }>()
);

export const addProductToSaveForLaterFail = createAction(
  '[Save For Later API] Add Product to Save For Later Fail',
  httpError()
);

export const updateProductFromSaveForLater = createAction(
  '[Save For Later Internal] Update Product From Save For Later',
  payload<{ saveForLaterUpdate: UpdateSaveForLaterType }>()
);

export const updateProductFromSaveForLaterSuccess = createAction(
  '[Save For Later API] Update Product From Save For Later Success',
  payload<{ saveForLaterList: SaveForLater }>()
);

export const updateProductFromSaveForLaterFail = createAction(
  '[Save For Later API] Update Product From Save For Later Fail',
  httpError()
);

export const removeProductFromSaveForLater = createAction(
  '[Save For Later Internal] Remove Product From Save For Later',
  payload<{ wishlistLineItemId: string; successMessage?: MessagesPayloadType }>()
);

export const removeProductFromSaveForLaterSuccess = createAction(
  '[Save For Later API] Remove Product From Save For Later Success',
  payload<{ saveForLaterList: SaveForLater; successMessage?: MessagesPayloadType }>()
);

export const removeProductFromSaveForLaterFail = createAction(
  '[Save For Later API] Remove Product From Save For Later Fail',
  httpError()
);

export const resetSaveForLater = createAction('[Save For Later Internal] Reset Save For Later');

export const moveSaveForLaterProductToBasket = createAction(
  '[Save For Later Internal] Move Save For Later Product To Basket',
  payload<{ saveForLaterLineItem: SaveForLaterlineItem; successMessage?: MessagesPayloadType }>()
);

export const moveSaveForLaterProductToBasketSuccess = createAction(
  '[Save For Later API] Move Save For Later Product To Basket Success',
  payload<{ saveForLaterList: SaveForLater; successMessage?: MessagesPayloadType }>()
);

export const moveSaveForLaterProductToBasketFail = createAction(
  '[Save For Later API] Move Save For Later Product To Basket Fail',
  httpError()
);
